<template>
  <div class="page403-content">
    <div class="page403-content_block">
      <span class="page403-content_block__mistake-number">{{$route.query.code}}</span>
      <div v-if="$route.query.code === 403" class="page403-content_block__mistake-block">
        <span class="page403-content_block__mistake-text">{{$t('errors.403')}}</span>
        <a class="page403-content_block__mistake-link btn_blue btn" @click="logout" :href="logoutLink">{{$t('errors.login')}}</a>
<!--        <template v-if="code === 403">К сожалению, у вас нет доступа к этой данной странице</template>-->
<!--        <template v-if="code === 404">К сожалению, запрашиваемая вами<br />страница не найдена…</template>-->
<!--        <template v-if="code === 500">Ошибка сервера.<br>Повторите попытку позднее</template>-->
      </div>
    </div>
  </div>
</template>

<script>
  import config from "@/config"
  import cookie from 'js-cookie'
export default {
  name: 'NotFound',
  data() {
    return {
      queryCode: 403,
      logoutLink: config.MK_BACKOFFICE_URL + 'login/?next=' + window.location.origin
    }
  },
  computed: {
    code() {
      return +this.$route.query.code
    },
  },
  created() {
    if (!this.$route.query.code) {
      this.$route.query.code = this.queryCode
    }
  },
  methods: {
    logout() {
      cookie.remove("access");
      cookie.remove("refresh");
      cookie.remove("role");
      cookie.remove("my_cookie");
      if (cookie.get("authMimk")) {
        cookie.remove("authMimk");
      }
      window.location.href = "https://backoffice.kodland.org/ru/login/";
    },
  }
}
</script>

<style lang="scss" scoped>
.page403 {
  background: #EEEFF4;
  &-content {
    height: 100vh;
    &_block {
      font-family: 'Open Sans', sans-serif;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      &__mistake-number{
        display: block;
        text-align: center;
        font-size: 200px;
        font-weight: bold;
        opacity: .8;
      }
      &__mistake-text{
        font-size: 24px;
        margin: 20px auto;
        text-align: center;
        display: inline-block;
        width: 100%;
      }
      &__mistake-link{
        margin: 0 auto;
      }
    }
  }
}
</style>
